module.exports = __webpack_public_path__ + "static/media/04_Ajajaj_eq 05-14.07a34b33.mp3";